const createConcurrencyLimiter = (maxConcurrency) => {
  let activeCount = 0;
  const queue = [];

  const next = () => {
    if (activeCount >= maxConcurrency) return;
    const queued = queue.shift();
    if (!queued) return;

    activeCount += 1;
    queued()
      .catch(() => {})
      .finally(() => {
        activeCount -= 1;
        next();
      });
  };

  return (task) =>
    new Promise((resolve, reject) => {
      const run = async () => {
        try {
          const result = await task();
          resolve(result);
        } catch (error) {
          reject(error);
        }
      };

      queue.push(run);
      next();
    });
};

// Shared limiter for the Installation list.
// Keeps backend-heavy endpoints from being hammered in parallel.
const runInstallationRequest = createConcurrencyLimiter(1);

// Simple per-session cache to avoid duplicate fetches during remounts/rerenders.
// Key: string -> Promise<any>
const inFlightOrResolved = new Map();

export const runCachedInstallationRequest = (key, task) => {
  if (inFlightOrResolved.has(key)) return inFlightOrResolved.get(key);
  const promise = runInstallationRequest(task).finally(() => {});
  inFlightOrResolved.set(key, promise);
  return promise;
};
